import { useFormContext } from "react-hook-form";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormTextField } from "@covertree/ui";

import { HomeDetailsForm } from "../validatorsAndTypes/homeDetailsAndConstructionForm";

interface Props {
  name?: string;
  label?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  fontSize?: number;
  labelFontSize?: number;
}

export function HomeHudNumberInput({
  name = "homeHudNumber",
  label = "What is your home's HUD tag number or Serial Number?",
  tooltip = "Your lender may reject your policy if this number isn't provided.",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { homeHudNumber } = useNewBusinessSelector(selectBasicQuestions);

  const { control, setValue } = useFormContext<HomeDetailsForm>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    setValue(name as keyof HomeDetailsForm, value === "" ? null : value, {
      shouldValidate: true,
    });
  };

  return (
    <FormTextField
      id="homeHudNumber"
      dataTestId="home-hud-number-input"
      name={name}
      label={homeHudNumber?.label ?? label}
      tooltip={homeHudNumber?.tooltip ?? tooltip}
      control={control}
      optional
      disabled={disabled}
      onChange={handleChange}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
    />
  );
}
